import React, { useState, useEffect } from 'react';
import { Menu, X, Send } from 'lucide-react';
// import Container from '../ui/Container'; // Не используется в предоставленном коде, закомментировано
import Button from '../ui/Button';
import { DATA } from '../../data'; // Предполагается, что DATA.navigation доступен
import { getTgLink } from '../../utils/telegram';
import { NavigationItem } from '../../types';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id: string): void => {
    setMobileOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleLogoClick = (): void => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileOpen]);

  const getLogoTextColor = (): string => {
    if (mobileOpen) {
      return 'text-brand-dark';
    }
    if (isScrolled) {
      return 'text-brand-dark';
    }
    return 'text-brand-white';
  };

  const getMenuIconColor = (): string => {
    if (mobileOpen) {
      // При открытом меню и скролле/без скролла
      return 'text-brand-dark bg-brand-white'; 
    }
    if (isScrolled) {
      // При закрытом меню и скролле
      return 'text-brand-dark bg-brand-white';
    }
    // При закрытом меню и без скролла
    return 'text-brand-white bg-transparent';
  };

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-white shadow-soft py-3' : 'bg-transparent py-4 md:py-6'}`}>
      <div className="grid-system items-center">
        <div className="flex items-center justify-between grid-content">
          <div className="flex items-center gap-2.5 cursor-pointer z-50" onClick={handleLogoClick}>
            <span className={`text-2xl md:text-3xl font-bold tracking-tight transition-colors ${getLogoTextColor()} display-md`}>
              Fun Dance
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className={`hidden lg:flex items-center px-2 py-1.5 rounded-full transition-all ${isScrolled ? 'bg-brand-white' : ''}`}>
            {DATA.navigation.map((item: NavigationItem) => (
              <button 
                key={item.id} 
                onClick={() => scrollTo(item.id)}
                className={`px-6 py-2.5 rounded-full ui-sm font-semibold transition-all duration-300 ${
                  isScrolled 
                    ? 'text-brand-dark hover:bg-brand-primary hover:text-brand-white' 
                    : 'text-brand-white hover:bg-brand-primary hover:text-brand-white'
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-6">
            <Button variant="primary" href={getTgLink("Привет! Хочу записаться на занятия!")} className="!py-3 !px-6 !text-sm !rounded-2xl">
              Записаться
            </Button>
          </div>

          {/* Mobile Menu Icon */}
          <button className={`lg:hidden p-2 rounded-lg z-50 transition-all ${getMenuIconColor()}`} onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Content */}
      {/* Добавлены flex-grow и text-center к родительскому контейнеру, 
        чтобы контент располагался по центру, и text-center к кнопкам.
      */}
      <div className={`fixed inset-0 bg-brand-white z-40 flex flex-col pt-24 px-6 transition-transform duration-300 ${mobileOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex flex-col gap-6 flex-grow items-center justify-center"> {/* Добавлено: items-center justify-center */}
          {DATA.navigation.map((item: NavigationItem) => (
            <button 
              key={item.id} 
              onClick={() => scrollTo(item.id)} 
              // Изменено: text-left заменен на text-center, который теперь наследуется от родителя
              className="py-2 text-brand-dark display-sm font-bold w-full" 
            >
              {item.label}
            </button>
          ))}
        </div>
        <div className="mt-auto mb-10 space-y-4 w-full max-w-sm mx-auto"> {/* Добавлено: w-full max-w-sm mx-auto для центрирования кнопки */}
          <Button variant="primary" className="w-full justify-center" href={getTgLink("Привет! Хочу записаться на занятия!")}>
            Записаться
          </Button>
          <p className="text-center text-brand-dark/70 caption-sm">ул. Тюленина, 5</p>
        </div>
      </div>
    </header>
  );
};

export default Header;